import { useContext } from 'react'
import Card3 from '../card/card3';
import FavoritesContext from '../../contexts/favorites-course';
import Helmet from "react-helmet";
function Favorite() {

    const favoritesCtx = useContext(FavoritesContext);
    let content;
    if (favoritesCtx.totalFavorites === 0) {
        content = <h1 style={{ paddingBottom: "8em", textAlign: "center", fontWeight: "811", marginTop: "8em", fontSize: "14pt" }} >شما هنوز مقاله ایی را اضافه نکرده اید</h1>
    } else {
        content = <Card3 meetups={favoritesCtx.favorites} />
    }

    return (
        <>
            <Helmet>
                <title>
                    ماه کورس | علاقه مندی ها
                </title>
            </Helmet>
            {content}
        </>

    )
}

export default Favorite